import React from 'react';
import { useTranslation } from 'react-i18next';

const resourceSections = [
  {
    title: 'header.resourcesActsByLaws',
    description: 'Key legislation, rules, regulations, and guidelines governing town planning and urban development in Andhra Pradesh.',
    href: '/resources/acts-bylaws',
    icon: 'ri-book-open-line',
    count: '16 Documents',
  },
  {
    title: 'header.resourcesGosCirculars',
    description: 'Government Orders, circulars, and notifications issued by DTCP and the Government of Andhra Pradesh.',
    href: '/resources/gos-circulars',
    icon: 'ri-file-text-line',
    count: '15 Orders',
  },
  {
    title: 'header.resourcesFaqs',
    description: 'Frequently asked questions about building permissions, layout approvals, LRS, BPS, and online portals.',
    href: '/resources/faqs',
    icon: 'ri-question-answer-line',
    count: '6 Categories',
  },
  {
    title: 'header.resourcesTraining',
    description: 'User manuals, video tutorials, fee structures, downloadable forms, and research studies.',
    href: '/resources/training',
    icon: 'ri-video-line',
    count: '5 Sections',
  },
];

export const ResourcesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Breadcrumb */}
      <nav className="flex items-center space-x-2 text-sm text-stone-500 mb-8">
        <a href="/" className="hover:text-amber-700 transition-colors">{t('header.home')}</a>
        <i className="ri-arrow-right-s-line text-stone-400"></i>
        <span className="text-stone-800 font-medium">{t('header.resources')}</span>
      </nav>

      {/* Page Header */}
      <div className="mb-12">
        <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">{t('resources.title')}</h1>
        <p className="text-lg text-stone-600 max-w-3xl">{t('resources.description')}</p>
      </div>

      {/* Resource Cards */}
      <div className="grid md:grid-cols-2 gap-6">
        {resourceSections.map((section, index) => (
          <a
            key={index}
            href={section.href}
            className="group bg-white border border-stone-200 rounded-lg p-6 hover:shadow-lg hover:border-amber-300 transition-all duration-200"
          >
            <div className="flex items-start space-x-4">
              <div className="w-14 h-14 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-amber-200 transition-colors">
                <i className={`${section.icon} w-7 h-7 flex items-center justify-center text-amber-600`}></i>
              </div>
              <div className="flex-1">
                <h2 className="text-lg font-bold text-stone-800 group-hover:text-amber-700 transition-colors mb-2">
                  {t(section.title)}
                </h2>
                <p className="text-sm text-stone-500 leading-relaxed mb-3">{section.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-amber-700 bg-amber-50 px-2 py-1 rounded-md font-medium">{section.count}</span>
                  <span className="text-sm text-amber-600 flex items-center group-hover:translate-x-1 transition-transform">
                    View All <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
